import { Link } from "react-router-dom";
import { topics } from "@/mocks/news";
import type { Article } from "@/mocks/news";
import { formatViews } from "@/utils/news";

export default function HotSidebar({ ranking }: { ranking: Article[] }) {
  return (
    <aside className="flex flex-col gap-6">
      <div className="bg-background-50 border border-background-200 rounded-lg p-5">
        <h3 className="flex items-center gap-2 text-base font-heading font-bold text-foreground-950 mb-4">
          <i className="ri-fire-fill text-primary-500" />
          热爆榜
        </h3>
        <ul className="space-y-3">
          {ranking.map((a, i) => (
            <li key={a.id} className="flex gap-3">
              <span
                className={`w-6 h-6 shrink-0 flex items-center justify-center rounded-md text-xs font-bold ${
                  i < 3
                    ? "bg-primary-500 text-white"
                    : "bg-background-100 text-foreground-500"
                }`}
              >
                {i + 1}
              </span>
              <div className="min-w-0">
                <Link
                  to={`/detail/${a.id}`}
                  className="text-sm text-foreground-800 hover:text-primary-600 transition-colors line-clamp-2 cursor-pointer"
                >
                  {a.title}
                </Link>
                <span className="text-xs text-foreground-400 flex items-center gap-1 mt-1">
                  <i className="ri-eye-line" />
                  {formatViews(a.views)}
                </span>
              </div>
            </li>
          ))}
        </ul>
      </div>

      <div className="bg-background-50 border border-background-200 rounded-lg p-5">
        <h3 className="flex items-center gap-2 text-base font-heading font-bold text-foreground-950 mb-4">
          <i className="ri-links-fill text-accent-600" />
          热门专题
        </h3>
        <ul className="space-y-4">
          {topics.map((t) => (
            <li key={t.id}>
              <Link
                to={`/topic/${t.id}`}
                className="block group cursor-pointer"
              >
                <div className="w-full h-24 rounded-md overflow-hidden mb-2">
                  <img
                    src={t.cover}
                    alt={t.title}
                    title={`${t.title} - 51爆料专题`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <span className="text-sm font-medium text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
                  {t.title}
                </span>
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div className="bg-secondary-500 rounded-lg p-5 text-white">
        <h3 className="flex items-center gap-2 text-base font-heading font-bold mb-2">
          <i className="ri-megaphone-line" />
          我要爆料
        </h3>
        <p className="text-sm text-white/85 leading-relaxed">
          有线索却无处发声？把你的见闻告诉我们，让更多人看到被忽略的真相。
        </p>
        <Link
          to="/contact"
          className="inline-flex items-center gap-1 mt-4 px-4 py-2 rounded-md bg-white text-secondary-700 text-sm font-medium hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
        >
          提交爆料线索
          <i className="ri-arrow-right-line" />
        </Link>
      </div>
    </aside>
  );
}